/**
 * Created by jmulder on 13/11/16.
 */

import {Psu} from "./psu";
import {validateConfig} from "@angular/router/src/config";


export class Cpu {

    constructor(
        public $key: string,                // database key (psuId)
        public location: string,            // place where CPU is installed (light pole)
        public description: string,         // type of board, software etc.
        public address: string,             // address of cpu board (CCID number)
        public installationDate: string,    // date of installation
        public simulate: boolean,           // NOT USED ANY MORE
        public usesField: string,           // NOT USED ANY MORE
        public rssi: string,                // signal strength
        public network: string,             // active network provider
        public lastSeen: string,            // last activity from PING or command
        public lastBooted: string,          // last boot moment (date / time)
        public swVersion: string,           // firmware version
        public psus: Psu[]
    ) {
    }

    static fromJson({$key, location, description, address, installationDate, simulate, usesField, rssi, network, lastSeen, lastBooted, swVersion, psus}) {
        return new Cpu($key, location, description, address, installationDate, simulate, usesField, rssi, network, lastSeen, lastBooted, swVersion, psus);
    }

    static fromJsonArray(json : any[]) : Cpu[] {
        return json.map(Cpu.fromJson);
    }

    static toCpuArray(json: any[]) : Cpu[] {
        var cpuArr: Cpu[] = [];

        for (var key in json) {
            var value = json[key];

            let cpu = <Cpu>({
                $key: key,
                location: value.location,
                description: value.description,
                address: value.address,
                installationDate: value.installationDate,
                simulate: value.simulate,
                usesField: value.usesField,
                rssi: value.rssi,
                network: value.network,
                lastSeen: value.lastSeen,
                lastBooted: value.lastBooted,
                swVersion: value.swVersion,
                psus: Psu.toPsuArray(value.psus ? value.psus : null)
            });
            cpuArr.push(cpu);
        }

        return cpuArr;

    }

}
